<div class="popup-container tlms-popup">
    <header>
        <div class="header" style="display:block"> {{heading}}</div>
        <button class="close" style="top:-3px" (click)="close()">
            <mat-icon>close</mat-icon>
        </button>
    </header>
    <div class="body" style="padding: 16px 24px 16px 24px;">
        <div class="form-row">

            <div class="form-col">
                <label class="catlabel">
                    Load Number:<span style="color:#ff0000">*</span>
                </label>
                <input type="text" class="content" [(ngModel)]="loadNumber" [maxlength]="20"
                    [disabled]="eventType=='EDIT'">
            </div>

            <div class="form-col">
                <label class="catlabel">
                    Expedite Date:<span style="color:#ff0000">*</span>
                </label>
                <input type="date" class="content" [(ngModel)]="expDate" [disabled]="eventType=='EDIT'">
            </div>

        </div>
        <div class="form-row">

            <!-- Column 1 -->
            <div class="form-col">
                <label class="catlabel">
                    Route Date:<span style="color:#ff0000">*</span>
                </label>
                <input type="date" class="content" [(ngModel)]="routeDate">
            </div>

            <!-- Column 2 -->
            <div class="form-col">
                <label class="catlabel">
                    Domicile:<span class="required">*</span>
                </label>

                <mat-form-field appearance="outline" class="fixed-select" subscriptSizing="dynamic">
                    <mat-select [(ngModel)]="domicile" (selectionChange)="domicileListChange()" disableOptionCentering
                        [placeholder]="'Select'">

                        <mat-option>
                            <ngx-mat-select-search [formControl]="domicileFilterCtrl" placeholderLabel="Search"
                                noEntriesFoundLabel="No results">
                            </ngx-mat-select-search>
                        </mat-option>

                        <mat-option *ngFor="let dom of filteredDomiciles | async" [value]="dom">
                            {{ dom.label }}
                        </mat-option>

                    </mat-select>
                </mat-form-field>

            </div>

        </div>
        <div class="form-row">


            <div class="form-col">
                <label class="catlabel">
                    Route:<span class="required">*</span>
                </label>

                <mat-form-field appearance="outline" class="fixed-select" subscriptSizing="dynamic">
                    <mat-select [(ngModel)]="route" disableOptionCentering [placeholder]="'Select'"
                        [disabled]="routeDropDown.length <= 1">

                        <mat-option>
                            <ngx-mat-select-search [formControl]="routeFilterCtrl" placeholderLabel="Search"
                                noEntriesFoundLabel="No results">
                            </ngx-mat-select-search>
                        </mat-option>

                        <mat-option *ngFor="let dom of filteredRoutes | async" [value]="dom">
                            {{ dom.label }}
                        </mat-option>

                    </mat-select>
                </mat-form-field>

            </div>
            <div class=form-col>
                <label class="catlabel">Run:<span style="color:#ff0000">*</span></label>
                <input type="text" class="content" [(ngModel)]="run" [maxlength]="2">
            </div>
        </div>
        <div class="form-row">

            <!-- Column 1: Mileage -->
            <div class="form-col">
                <label class="catlabel">
                    Mileage:<span style="color:#ff0000">*</span>
                </label>

                <input type="number" class="content" [(ngModel)]="mileage">
            </div>

            <!-- Column 2: Cost Centre -->
            <div class="form-col">
                <label class="catlabel">
                    Cost Center:<span class="required">*</span>
                </label>

                <mat-form-field appearance="outline" class="fixed-select" subscriptSizing="dynamic">

                    <mat-select [(ngModel)]="costCentre" disableOptionCentering [placeholder]="'Select'">

                        <!-- SEARCH BOX -->
                        <mat-option>
                            <ngx-mat-select-search [formControl]="costCentreFilterCtrl" placeholderLabel="Search"
                                noEntriesFoundLabel="No results">
                            </ngx-mat-select-search>
                        </mat-option>

                        <!-- OPTIONS -->
                        <mat-option *ngFor="let dom of filteredCostCentres | async" [value]="dom">
                            {{ dom.label }}
                        </mat-option>

                    </mat-select>
                </mat-form-field>

            </div>

        </div>
        <div class="form-row">

            <!-- Column 1: Allocation Rate -->
            <div class="form-col">
                <label class="catlabel">
                    Allocation Rate:<span style="color:#ff0000">*</span>
                </label>

                <input type="number" class="content" [(ngModel)]="allocationRate">
            </div>

            <!-- Column 2: Total Cost -->
            <div class="form-col">
                <label class="catlabel">
                    Total Cost:<span style="color:#ff0000">*</span>
                </label>

                <input type="text" class="content" [(ngModel)]="totalCost" (keyup)="validate($event,'value')"
                    (keypress)="keyPressAlphaNumeric($event)">
            </div>

        </div>
        <div class="form-row">

            <!-- Column 1: Reason ID -->
            <div class="form-col">
                <label class="catlabel">
                    Reason ID:<span class="required">*</span>
                </label>

                <mat-form-field appearance="outline" class="fixed-select" subscriptSizing="dynamic">

                    <mat-select [(ngModel)]="reasonId" disableOptionCentering [placeholder]="'Select'">

                        <!-- SEARCH -->
                        <mat-option>
                            <ngx-mat-select-search [formControl]="reasonIdFilterCtrl" placeholderLabel="Search"
                                noEntriesFoundLabel="No results">
                            </ngx-mat-select-search>
                        </mat-option>

                        <!-- OPTIONS -->
                        <mat-option *ngFor="let dom of filteredReasonIds | async" [value]="dom">
                            {{ dom.label }}
                        </mat-option>

                    </mat-select>
                </mat-form-field>

            </div>

            <!-- Column 2: Vendor -->
            <div class="form-col">
                <label class="catlabel">
                    Vendor:<span class="required">*</span>
                </label>

                <mat-form-field appearance="outline" class="fixed-select" subscriptSizing="dynamic">

                    <mat-select [(ngModel)]="carrier" disableOptionCentering [placeholder]="'Select'">

                        <!-- SEARCH -->
                        <mat-option>
                            <ngx-mat-select-search [formControl]="carrierFilterCtrl" placeholderLabel="Search"
                                noEntriesFoundLabel="No results">
                            </ngx-mat-select-search>
                        </mat-option>

                        <!-- OPTIONS -->
                        <mat-option *ngFor="let dom of filteredCarriers | async" [value]="dom">
                            {{ dom.label }}
                        </mat-option>

                    </mat-select>
                </mat-form-field>

            </div>

        </div>
    </div>
    <label *ngIf="errormsg" class="errormsg"> {{errormsg}} </label>
    <div class="cfooter d-flex justify-content-between align-items-center popup-footer">

        <button (click)="onNoClick()" class="mCancel"> CANCEL</button>

        <button mat-raised-button class="black-btn" style="display: inline;" (click)="saveClick()">SAVE</button>
    </div>
</div>